import { useGetContextsQuery } from "Auth/Api/Queries/Context/useGetContextsQuery";
import { AddRoleOnboarding } from "Components/Roles/Onboarding/AddRoleOnboarding";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import { IdentityUserStatus, PartyType } from "Infrastructure/Api/Api";
import { AccessRoleCodes } from "Models/AccessRoleCodes";
import { Navigate } from "Navigation/Navigate";
import { appUrl } from "Utils/UrlUtils";

/**
 * Hosts the add-role wizard for the ACTIVE context. Reachable only while the active role grant is
 * still Onboarding — anything else routes back to the dashboard (completed roles resume nothing).
 */
export const AddRoleOnboardingPage = () => {
  const { data, isLoading } = useGetContextsQuery();

  if (isLoading) {
    return <CenteredCircularProgress />;
  }

  const activeContext = data?.contexts?.find(
    (context) =>
      context.identityUserPublicID === data.activeIdentityUserPublicID,
  );

  const isOnboardingBusinessRole =
    activeContext?.status === IdentityUserStatus.Onboarding &&
    (activeContext.accessRoleCode === AccessRoleCodes.Hunter ||
      activeContext.accessRoleCode === AccessRoleCodes.HunterPlus ||
      activeContext.accessRoleCode === AccessRoleCodes.Merchant);

  if (!activeContext || !isOnboardingBusinessRole) {
    return <Navigate to={appUrl("homepage")} replace />;
  }

  return (
    <AddRoleOnboarding
      role={
        activeContext.accessRoleCode as
          | typeof AccessRoleCodes.Hunter
          | typeof AccessRoleCodes.HunterPlus
          | typeof AccessRoleCodes.Merchant
      }
      partyType={activeContext.partyType ?? PartyType.SelfEmployed}
    />
  );
};
